import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-download-itt-action',
  templateUrl: './download-itt-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class DownloadIttActionComponent {
  @Input() product!: IProduct;
  @Input() assetType!: 'post-asset' | 'output-asset' | 'shoot-asset';

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private productsService: ProductsService,
  ) {}

  onDownload(): void {
    this.productsService
      .downloadImageToText(this.product.id!, this.assetType)
      .subscribe((blob) => {
        const fileName = this.buildFileName();
        this.downloadBlob(blob, fileName);
      });
  }

  private buildFileName(): string {
    return `${this.product.barcode}_${this.assetType}-content.csv`;
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const anchor = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}
